import React, { useEffect, useState } from "react";
import { View, Text } from "react-native";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import { FormattedMessage } from "react-intl";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const ChangePassword = ({ navigation }) => {
  const [password, setPassword] = useState("");

  useEffect(() => {
    resetPassword();
  }, [password]);

  function resetPassword() {
    if (password.length === 6) {
      navigation.navigate("NewPassword", { password: password });
    }
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="changePassword.titleTrocarSenha" />}
      />
      <View style={styles.container}>
        <View style={styles.containerTitle}>
          <Text style={styles.tittleTrocarSenha}>
            <FormattedMessage id="changePassword.titleTrocarSenha" />
          </Text>
        </View>
        <FormattedMessage id="changePassword.digiteSenhaAtual">
          {(label) => (
            <AuthCodeInput
              cellCount={6}
              isPassword={true}
              value={password}
              onValueChange={(value) => setPassword(value)}
              label={label}
            />
          )}
        </FormattedMessage>
        <View style={{ marginTop: 20 }}>
          <GoBackButton />
        </View>
      </View>
    </>
  );
};

export default ChangePassword;
